import { Component, type ReactNode } from 'react';

// Sayfanın çalışması için ŞART OLMAYAN parçalar (yüzen duyuru/test balonu,
// katlama altındaki katalog) için hata sınırı: chunk'ı yüklenemez ya da
// render'da çökerse sessizce hiçbir şey çizmez. Sınır olmadan hata rota
// sınırına kadar çıkıp TÜM sayfayı hata ekranıyla değiştiriyordu.
class SilentBoundary extends Component<
  { children: ReactNode; fallback?: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    return this.state.failed
      ? (this.props.fallback ?? null)
      : this.props.children;
  }
}

export default SilentBoundary;
